/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// Fix for the mobile "100vh" problem: CSS 100vh on mobile browsers refers to
// the viewport height with the browser toolbar hidden, causing phantom space
// at the bottom. We expose the real visible height as a --vh custom property
// so styles can use `calc(var(--vh, 1vh) * 100)` instead of `100vh`.
exports.onClientEntry = () => {
  const setVH = () => {
    const vh = window.innerHeight * 0.01
    document.documentElement.style.setProperty("--vh", `${vh}px`)
  }

  setVH()
  window.addEventListener("resize", setVH)
  window.addEventListener("orientationchange", setVH)
}

exports.shouldUpdateScroll = ({
    routerProps: { location },
    getSavedScrollPosition
  }) => {
  
    if (location.hash) {
      return false;
    }
  
    return true;
  };
  